module.exports = __webpack_public_path__ + "img/1078_1.adb76813.jpg";